import { render, staticRenderFns } from "./kosis.vue?vue&type=template&id=65d956ce&scoped=true"
import script from "./kosis.vue?vue&type=script&lang=js"
export * from "./kosis.vue?vue&type=script&lang=js"
import style0 from "./kosis.vue?vue&type=style&index=0&id=65d956ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d956ce",
  null
  
)

export default component.exports